import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import Comments from '../components/Comments';
import { HookImage } from '../components/GameImages';
import '../css.css';

const HOOK_TABLES = [
  { key: 'hook_clas', label: '클래식' },
  { key: 'hook_carp', label: '카프' },
  { key: 'hook_mhook', label: '마린' },
  { key: 'hook_jhead', label: '지그헤드' },
  { key: 'hook_triple', label: '트래블' },
  { key: 'hook_woffset', label: '웨이티드' },
  { key: 'hook_lfish', label: '베이트피쉬' },
  { key: 'hook_offset', label: '오프셋' },
  { key: 'hook_spinner', label: '스피너베이트&스커티드' },
];

const Page1 = () => {
  const [selectedTable, setSelectedTable] = useState(HOOK_TABLES[0].key);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`/api/hooks/${selectedTable}`);
        if (!response.ok) throw new Error('Network response was not ok');
        
        const fetchedData = await response.json();
        
        if (fetchedData.length > 0) {
          const firstRow = fetchedData[0];
          // name 컬럼을 제외한 컬럼들만 추출 (이름은 별도로 표시되므로)
          const dynamicColumns = Object.keys(firstRow).filter(col => col !== 'name');
          setColumns(dynamicColumns);
        }
        
        setData(fetchedData);
      } catch (error) {
        console.error('Error fetching data:', error);
        setData([]);
        setColumns([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedTable]);

  return (
    <>
      <h1 className="page-title">바늘 하중 정보</h1>
      <div className="skill-container">
        <div className="skill-filter-buttons">
          {HOOK_TABLES.map((tbl) => (
            <button
              key={tbl.key}
              onClick={() => setSelectedTable(tbl.key)}
              className={selectedTable === tbl.key ? 'active' : ''}
            >
              {tbl.label}
            </button>
          ))}
        </div>
        {loading ? (
          <div className="spinner-container">
            <LoadingSpinner height={80} width={80} color="#4fa94d" visible={true} />
          </div>
        ) : (
          <div className="page-content">
            <table className="oil-table" style={{ width: '100%', minWidth: '1200px' }}>
              <thead>
                <tr>
                  <th>사진</th>
                  <th>이름</th>
                  {columns.slice(2).map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((row, idx) => (
                  <tr key={row.id || idx}>
                    <td>
                      {row.filename ? (
                        <HookImage
                          filename={row.filename}
                          alt={row.name || row.filename}
                          className="hook-table-image"
                          onError={() => {
                            console.warn('Failed to load hook image:', row.filename);
                          }}
                        />
                      ) : null}
                    </td>
                    <td>{row.name}</td>
                    {columns.slice(2).map((col) => (
                      <td key={col}>{row[col]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <Comments pageName="hooks" />
    </>
  );
};

export default Page1;
